<template>
    <radial-progress-bar 
        :diameter="196" 
        :completed-steps="completed" 
        :total-steps="totalSteps"
        innerStrokeColor="#EEF1F3"
        :innerStrokeWidth="20"
        startColor="#005BB5"
        stopColor="#0071E1"
        :strokeWidth="20"
        strokeLinecap="square"

    >
        <div class="infographics__radial-inner">
            <div class="infographics__radial-value">{{ value }}%</div>
            <div class="infographics__radial-title">{{ title }}</div>
        </div>
    </radial-progress-bar>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'

export default {
    props: ["value", "title"],
    components: {
        RadialProgressBar
    },
    data() {
        return {
            completed: 0,
            totalSteps: 100
        }
    },
    mounted() {
        this.completed = this.value
    }
}
</script>